var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "containers", style: _vm.styleCss },
    [
      _vm.isShowHeader
        ? _c("Headers", { attrs: { goBack: _vm.goBack } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "contexts", style: _vm.contexts },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }